import { useState } from 'react';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { SaveClientFlags } from '@sdk/authentication/types';

import PopupSurveyContainer from '@web/components/survey/PopupSurveyContainer';
import SurveyCloseButton from '@web/components/survey/SurveyCloseButton';
import SubscriptionPreferenceSteps from '@web/components/subscriptionPreferenceSurvey/subscriptionPreferenceSurveySteps';
import { useSubscriptionPreferenceSurvey } from '@web/components/subscriptionPreferenceSurvey/subscriptionPreferenceSurvey.hooks';

export type Props = {
  user: AuthUserType;
  locationsCount: number;
  totalUserCount: number;
  joinedUserCount: number;
  wasFreemiumSelected: boolean;
  saveClientFlags: SaveClientFlags;
  forceDisplay: boolean;
  onClose?: VoidFunction;
};

const SubscriptionPreferenceSurvey = (props: Props) => {
  const [reason, setReason] = useState('');
  const [other, setOther] = useState('');
  const [comment, setComment] = useState('');
  const { closeModal, submitSurvey, isVisible, isToastBilling } = useSubscriptionPreferenceSurvey({
    reason,
    other,
    comment,
    ...props,
  });

  if (!isVisible) {
    return null;
  }

  return (
    <PopupSurveyContainer>
      <SurveyCloseButton onClose={closeModal} />
      <SubscriptionPreferenceSteps
        reason={reason}
        setReason={setReason}
        comment={comment}
        setComment={setComment}
        other={other}
        setOther={setOther}
        submitForm={() => submitSurvey()}
        isToastBilling={isToastBilling}
        onClose={closeModal}
      />
    </PopupSurveyContainer>
  );
};

export default SubscriptionPreferenceSurvey;
